export const hasAnyActiveSubscription = (subscribedCourses = []) => {
  return subscribedCourses.some((course) => {
    return (
      course.subscription_status === "active" &&
      new Date(course.access_end).getTime() > Date.now()
    );
  });
};

export const hasCourseAccess = (subscribedCourses = [], requiredCourse) => {
  if (!requiredCourse) return true;

  const course = subscribedCourses.find(
    (item) => item.course === requiredCourse,
  );

  if (!course) return false;

  return (
    course.subscription_status === "active" &&
    new Date(course.access_end).getTime() > Date.now()
  );
};
